import { ComplaintsType } from "@/src/data/types";
import { Eye, MoreHorizontal, Trash } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteMessage } from "../../../API/Contact/contactService";
import { AlertModal } from "../../modal/alert-modal";
import { InformationModal } from "../../modal/information-modal";
import { Button } from "../../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";

interface CellActionProps {
  data: ComplaintsType;
}

export const CellAction: React.FC<CellActionProps> = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [showData, setShowDataOpen] = useState(false);
  const [complaintData, setComplaintData] = useState<ComplaintsType | null>(
    null
  );

  const router = useNavigate();

  const onConfirm = async () => {
    await deleteMessage(data.id);
    setTimeout(() => {
      router(0);
    }, 3000);
  };
  return (
    <>
      <AlertModal
        isOpen={open}
        onClose={() => setOpen(false)}
        onConfirm={onConfirm}
      />
      <InformationModal
        isOpen={showData}
        onClose={() => setShowDataOpen(false)}
        complaintData={complaintData}
      />
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="w-8 h-8 p-0">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal className="w-4 h-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Actions</DropdownMenuLabel>

          <DropdownMenuItem
            onClick={() => {
              setShowDataOpen(true);
              setComplaintData(data);
            }}
          >
            <Eye className="w-4 h-4 mr-2" /> Consulter
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => setOpen(true)}>
            <Trash className="w-4 h-4 mr-2" /> Supprimer
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
